const TUIChat = {
  '查看内容': 'Lihat kandungan',
  '立即填写': 'Isi segera',
  '已提交': 'Telah dihantar',
  '不能为空': 'Tidak boleh kosong',
  '提交': 'Hantar',
  '撤回': 'Tarik Balik',
  '删除': 'Padam',
  '复制': 'Salin',
  '重新发送': 'Hantar Semula',
  '转发': 'Teruskan',
  '引用': 'Petik',
  '打开': 'Buka',
  '已读': 'Telah Dibaca',
  '未读': 'Belum Dibaca',
  '人已读': 'Orang Telah Membaca',
  '人未读': 'Orang Belum Membaca',
  '人关闭阅读状态': 'Orang Menutup Status Bacaan',
  '全部已读': 'Semua Telah Dibaca',
  '消息详情': 'Butiran Mesej',
  '关闭阅读状态': 'Tutup',
  '您': 'Anda',
  '撤回了一条消息': 'Telah Menarik Balik Satu Mesej',
  '重新编辑': 'Edit Semula',
  '我': 'Saya',
  '自定义消息': 'Mesej Tersuai',
  '查看更多': 'Lihat Lebih Banyak',
  '确认重发该消息？': 'Sahkan Untuk Hantar Semula Mesej Ini?',
  '取消': 'Batal',
  '确定': 'Sahkan',
  '转发给': 'Teruskan Kepada',
  '请输入消息': 'Sila Masukkan Mesej',
  '描述': 'Deskripsi',
  '经度': 'Longitud',
  '纬度': 'Latitud',
  '图片': '[Gambar]',
  '语音': '[Suara]',
  '视频': '[Video]',
  '表情': '[Emotikon]',
  '文件': '[Fail]',
  '自定义': '[Mesej Tersuai]',
  '管理员开启全员禁言': 'Pentadbir Mengaktifkan Senyap Semua',
  '您已被管理员禁言': 'Anda Telah Disenyapkan Oleh Pentadbir',
  '按Enter发送': 'Tekan Enter Untuk Hantar',
  '单击下载': 'Klik Untuk Muat Turun',
  '下载':'Muat turun',
  '该消息不存在': 'Mesej Ini Tidak Wujud',
  '无法定位到原消息': 'Tidak Dapat Menemukan Mesej Asal',
  '对方正在输入': 'Pihak Lain Sedang Menulis...',
  '回到最新位置': '',
  '条新消息': 'Mesej Baru',
  '点此投诉': 'Klik Sini Untuk Aduan',
  '语音通话': 'Panggilan Suara',
  '视频通话': 'Panggilan Video',
  '发起群语音': 'Mulakan Panggilan Suara Kumpulan',
  '发起群视频': 'Mulakan Panggilan Video Kumpulan',
  '已接听': 'Telah Dijawab',
  '拒绝通话': 'Tolak Panggilan',
  '无应答': 'Tiada Jawapan',
  '取消通话': 'Batal Panggilan',
  '发起通话': 'Mulakan Panggilan',
  '结束群聊': 'Tamatkan Sembang Kumpulan',
  '通话时长': 'Tempoh Panggilan',
  '欢迎使用TUICallKit': 'Selamat Datang Menggunakan Komponen Panggilan Audio dan Video Tencent Cloud TUICallKit',
  '检测到您暂未集成TUICallKit，无法体验音视频通话功能': 'Dikesan Anda Belum Mengintegrasikan TUICallKit, Tidak Dapat Mengalami Fungsi Panggilan Audio dan Video.',
  '请点击': 'Sila Klik',
  '集成TUICallKit': 'Integrasi TUICallKit',
  '开通腾讯实时音视频服务': 'Aktifkan Perkhidmatan Audio dan Video Masa Nyata Tencent',
  '进行体验': 'Untuk Mengalami.',
  '您当前购买使用的套餐包暂未开通此功能': 'Pakej yang Anda Beli Sekarang Tidak Mengaktifkan Fungsi Ini.',
  '系统消息': 'Mesej Sistem',
  '转人工服务': 'Alihkan Ke Perkhidmatan Manusia',
  '点击处理': 'Klik untuk proses',
  '发送失败': 'Gagal menghantar',
  '复制成功': 'Berjaya disalin',
  '回复': 'Balas',
  '回复详情': 'Butiran Balasan',
  '拒绝': 'Menolak',
  '聊天记录': 'Rekod Perbualan',
  '内容包含敏感词汇': 'Kandungan mengandungi perkataan sensitif',
  '您当前购买使用的套餐包暂未开通群消息已读回执功能': 'Pakej yang anda beli dan gunakan belum membuka fungsi tanda terima bacaan mesej kumpulan',
  '您当前购买使用的套餐包暂未开通在线用户列表功能': 'Pakej yang anda beli dan gunakan belum membuka fungsi senarai pengguna dalam talian',
  '您有': 'Anda mempunyai',
  '涉及敏感内容': 'Melibatkan kandungan sensitif',
  '申请加入': 'Permohonan Sertai',
  '条回复': 'balasan',
  '条入群申请': 'permohonan sertai kumpulan',
  '同意': 'Setuju',
  '图片消息失败,无效的图片格式': 'Gagal menghantar mesej gambar, format gambar tidak sah',
  '位置': 'Lokasi',
  '文件不存在,请检查文件路径是否正确': 'Fail tidak wujud, sila periksa laluan fail sama ada betul',
  '文件大小超出了限制,如果上传文件,最大限制是100MB': 'Saiz fail melebihi had, jika memuat naik fail, had maksimum adalah 100MB',
  '文件消息失败,禁止发送违规封禁的文件': 'Gagal menghantar mesej fail, larangan menghantar fail yang melanggar peraturan',
  '无法查看': 'Tidak dapat dilihat',
  '无法收听': 'Tidak dapat didengar',
  '正在加载': 'Sedang dimuatkan',
  '加载结束': 'Pemuatan selesai',
  '消息': 'Mesej',
  '消息或者资料中文本存在敏感内容,发送失败': 'Gagal menghantar mesej atau maklumat, terdapat kandungan sensitif dalam teks',
  '消息长度超出限制,消息长度不要超过12K': 'Panjang mesej melebihi had, panjang mesej tidak boleh melebihi 12K',
  '消息中图片存在敏感内容,发送失败': 'Gagal menghantar mesej, terdapat kandungan sensitif dalam gambar',
  '选择提醒的人': 'Pilih orang yang ingin diingatkan',
  '已过撤回时限': 'Had masa untuk menarik balik telah berlalu',
  '已拒绝': 'Ditolak',
  '已同意': 'Disetujui',
  '引用失败': 'Gagal mengutip',
  '翻译': 'Terjemahan',
  '转文字': 'Teks ke Audio',
  '隐藏': 'Sembunyi',
  '腾讯云 IM': 'Tencent Cloud Chat',
  '空': 'Kosong',
  '文本包含本地审核拦截词': 'Teks mengandungi perkataan penyaringan tempatan',
  '按住说话': 'Tekan dan bercakap',
  '松开发送': 'Angkat untuk menghantar',
  '松手取消': 'Angkat untuk membatalkan',
  '录音结束提醒': 'Rakaman akan berhenti dalam',
  '语音播放失败': 'Pemutaran suara gagal',
  '请检查麦克风访问权限': 'Sila semak kebenaran akses mikrofon',
  '按压时间过短，请按压超过1秒': 'Masa tekan terlalu pendek, tekan lebih daripada 1 saat',
  '正在录音': 'Sedang merekod',
  '继续上滑可取消': 'Terus geser ke atas untuk membatalkan',
  '松开手指 取消发送': 'Lepaskan jari untuk membatalkan penghantaran',
  '此机型暂不支持复制功能': 'Model ini tidak menyokong fungsi salin sementara',
  '请开通翻译功能': 'Sila aktifkan fungsi terjemahan',
  '请开通语音转文字功能': 'Sila aktifkan fungsi penukaran suara ke teks',
  '翻译中': 'Sedang diterjemahkan',
  '转换中': 'Sedang menukar',
  '由IM提供翻译支持': 'Disokong oleh IM untuk terjemahan',
  '所有人': 'Semua orang',
  '已达到表情回应上限数量': 'Jumlah had tindak balas emosi telah dicapai',
  '等': 'dan lain-lain',
  '人': 'orang',
  '返回': 'Kembali',
  '关闭': 'Tutup',
  '多选': 'Pilihan pelbagai',
  '合并转发': 'Gabungkan dan hantar',
  '逐条转发': 'Hantar satu persatu',
  '未选择消息': 'Tiada mesej dipilih',
  '[草稿]': '[Draf]',
  '[消息]': '[Mesej]',
  '[文本]': '[Teks]',
  '[自定义消息]': '[Mesej Tersuai]',
  '[图片]': '[Gambar]',
  '[音频]': '[Audio]',
  '[语音]': '[Suara]',
  '[视频]': '[Video]',
  '[文件]': '[Fail]',
  '[位置]': '[Lokasi]',
  '[地理位置]': '[Lokasi]',
  '[动画表情]': '[Emoji Animasi]',
  '[群提示]': '[Petunjuk Kumpulan]',
  '[群提示消息]': '[Mesej Petunjuk Kumpulan]',
  '[聊天记录]': '[Rekod Perbualan]',
  '[机器人自定义消息]': '[Mesej Tersuai Robot]',
  '引用内容已撤回': 'Kandungan rujukan telah ditarik balik',
  '群聊的聊天记录': 'Rekod perbualan dalam kumpulan',
  '和': 'dan',
  '的聊天记录': 'rekod perbualan',
  '请升级IMSDK到v2.10.1或更高版本查看此消息': 'Sila naik tarafkan IMSDK ke v2.10.1 atau versi yang lebih tinggi untuk melihat mesej ini',
  '该群聊已被解散': 'Perbualan kumpulan ini telah dibubarkan',
  '您已被管理员移出群聊': 'Anda telah dikeluarkan daripada perbualan kumpulan oleh pentadbir',
  '您已退出该群聊': 'Anda telah keluar daripada perbualan kumpulan ini',
  '您已被禁止聊天': 'Anda telah dilarang berbual',
  '按Enter发送，Ctrl+Enter换行': 'Tekan Enter untuk menghantar, Ctrl+Enter untuk baris baru',
  '账号被强制下线': 'Akaun dipaksa keluar',
  '登录失败': 'Gagal log masuk',
  '链接':'[Pautan]',
};

export default TUIChat;
